import { PriceRecord } from '@tassat/fred-definitions';
import { createSelector } from 'reselect';

import { getPrices } from 'Selectors/common';

type PricesAsCurCode = {
    [curCode: string]: PriceRecord;
};

export const getPricesAsCurCode = createSelector(
    [getPrices],
    (prices) => {
        const pricesAsCurCode = {} as PricesAsCurCode;

        Object.keys(prices)
            .forEach(key => {
                if (Object.prototype.hasOwnProperty.call(prices, key)) {
                    const curCode = prices[key].CurCode;
                    pricesAsCurCode[curCode] = prices[key];
                }
            });

        return pricesAsCurCode;
    }
);